import { ADD_NEW_USER_ERROR, ADD_NEW_USER_SUCCESS, BULK_UPLOAD, BULK_UPLOAD_ERROR, BULK_UPLOAD_SUCCESS, UPDATE_ATTENDANCE, UPDATE_TIMESHEET, UPDATE_PENALTY, UPDATE_NEW_USER, UPDATE_NEW_USER_ERROR, UPDATE_NEW_USER_SUCCESS, GET_USER_DEVICES, GET_USER_DEVICES_SUCCESS, GET_USER_DEVICES_ERROR, SET_PRIMARY_DEVICE, SET_PRIMARY_DEVICE_SUCCESS, SET_PRIMARY_DEVICE_ERROR } from "./actiontype"
import { ADD_NEW_USER } from "./actiontype"
import { USER_DATA, USER_DATA_ERROR, USER_DATA_SUCCESS, ALL_USER_DATA_SUCCESS } from "./actiontype"

export const getUsersList = (params) => {
    return {
      type: USER_DATA,
      payload: params
    }
  }
  export const userListSuccess = response => {
    return {
      type: USER_DATA_SUCCESS,
      payload:response,
    }
  }
   
  export const allUserListSuccess = response => {
    return {
      type: ALL_USER_DATA_SUCCESS,
      payload:response,
    }
  }

  export const userListError = erordata => {
    return {
      type: USER_DATA_ERROR,
      payload: erordata,
    }
  }
export const onAddnewUser = (params,callback) => {
    return {
      type: ADD_NEW_USER,
      payload: params,
      callback
    }
  }
  export const onAddnewUserSuccess = response => {
    return {
      type: ADD_NEW_USER_SUCCESS,
      payload:response,
    }
  }
  export const onAddnewUserError = erordata => {
    return {
      type: ADD_NEW_USER_ERROR,
      payload: erordata,
    }
  }
export const onupdateUser = (params,callback) => {
    return {
      type: UPDATE_NEW_USER,
      payload: params,
      callback
    }
  }
  export const onupdateUserSuccess = response => {
    return {
      type: UPDATE_NEW_USER_SUCCESS,
      payload:response,
    }
  }
  export const onupdateUserError = erordata => {
    return {
      type: UPDATE_NEW_USER_ERROR,
      payload: erordata,
    }
  }
export const postuploadData = (params,callback) => {
    return {
      type: BULK_UPLOAD,
      payload: params,
      callback
    }
  }
  export const postuploadDataSuccess = response => {
    return {
      type: BULK_UPLOAD_SUCCESS,
      payload:response,
    }
  }
  export const postuploadDataError = erordata => {
    return {
      type: BULK_UPLOAD_ERROR,
      payload: erordata,
    }
  }

  export const updateAttendance = (response, callback) => {
    return {
      type: UPDATE_ATTENDANCE,
      payload:response,
      callback
    }
  }

  export const updateTimesheet = (response, callback) => {
    return {
      type: UPDATE_TIMESHEET,
      payload:response,
      callback
    }
  }

  export const updatePenalty = (response, callback) => {
    return {
      type: UPDATE_PENALTY,
      payload:response,
      callback
    }
  }

  export const getUserDevices = (userid, callback) => {
    return {
      type: GET_USER_DEVICES,
      payload: userid,
      callback
    }
  }
  export const getUserDevicesSuccess = response => {
    return {
      type: GET_USER_DEVICES_SUCCESS,
      payload:response,
    }
  }
  export const getUserDevicesError = erordata => {
    return {
      type: GET_USER_DEVICES_ERROR,
      payload: erordata,
    }
  }

  export const setPrimaryDevice = (params, callback) => {
    return {
      type: SET_PRIMARY_DEVICE,
      payload: params,
      callback
    }
  }
  export const setPrimaryDeviceSuccess = response => {
    return {
      type: SET_PRIMARY_DEVICE_SUCCESS,
      payload:response,
    }
  }
  export const setPrimaryDeviceError = erordata => {
    return {
      type: SET_PRIMARY_DEVICE_ERROR,
      payload: erordata,
    }
  }